import React from 'react';
import { clsx } from 'clsx';
import classes from './TokenBase.module.css.js';
import { BoxWithFallback } from '../internal/components/BoxWithFallback.js';
import { jsx } from 'react/jsx-runtime';

const tokenSizes = {
  small: '16px',
  medium: '20px',
  large: '24px',
  xlarge: '32px'
};
const defaultTokenSize = 'medium';
const isTokenInteractive = ({
  as = 'span',
  onClick,
  onFocus,
  tabIndex = -1,
  disabled
}) => {
  if (disabled) {
    return false;
  }
  return Boolean(onFocus || onClick || tabIndex > -1 || ['a', 'button'].includes(as));
};
const TokenBase = /*#__PURE__*/React.forwardRef(({
  onRemove,
  onKeyDown,
  id,
  className,
  size = defaultTokenSize,
  isSelected: _isSelected,
  as = 'span',
  ...rest
}, forwardedRef) => {
  return /*#__PURE__*/jsx(BoxWithFallback, {
    as: as,
    onKeyDown: event => {
      onKeyDown && onKeyDown(event);
      if ((event.key === 'Backspace' || event.key === 'Delete') && onRemove) {
        onRemove();
      }
    },
    className: clsx(classes.TokenBase, className),
    "data-cursor-is-interactive": isTokenInteractive(rest),
    "data-size": size,
    id: id === null || id === undefined ? undefined : id.toString(),
    ...rest,
    ref: forwardedRef
  });
});

export { TokenBase as default, defaultTokenSize, isTokenInteractive, tokenSizes };
